export default __webpack_public_path__ + "bfe8b5da3773a20949265a492851ab2e.svg";